import { atomFromQueryString } from '~/shared/state';

// 🟣🟣🟣 PARAMS
export const $searchTerm = atomFromQueryString.string('q');
export const $limit = atomFromQueryString.number('limit', 25);
export const $offset = atomFromQueryString.number('offset', 0);
